import { render, staticRenderFns } from "./addedit-threat.vue?vue&type=template&id=246d681c"
import script from "./addedit-threat.vue?vue&type=script&lang=js"
export * from "./addedit-threat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports